// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.c4e-validator-image[data-v-51db5f36] {\n  border-radius: 50%;\n  max-height: 100%;\n  max-width: 100%;\n  background-size: contain;\n  box-shadow: 0 0 3px 0 #b7bdc3;\n  margin-right: 0.5rem;\n  height: 2.5rem;\n  /* min-height: 2.5rem; */\n  width: 2.5rem;\n  /* min-width: 2.5rem;  */\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
